import { render } from "./finance_compliance.html?vue&type=template&id=f228c9f6&external"
import script from "./finance_compliance.js?vue&type=script&lang=js&external"
export * from "./finance_compliance.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__